module.exports = __webpack_public_path__ + "img/128.1cc11500.jpg";